<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Tabs & accordions component
 */
export default {
  page: {
    title: "General Settings",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      pharmacy_stock_value:0,
      title: "General Settings",
      items: [
        {
          text: "Advanced Settings",
        },
        {
          text: "General Settings ",
          active: true,
        },
      ],

      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "role_name",
          sortable: true,
          label: "ROLE",
        },
        {
          key: "lab_field",
          sortable: false,
          label: "LABORATORY",
        },
        {
          sortable: false,
          key: "rad",
          label: "RADIOLOGY",
        },
        {
          sortable: false,
          key: "consult",
          label: "CONSULTATION",
        },
        {
          sortable: false,
          key: "proc",
          label: "PROCEDURE",
        },
        {
          sortable: false,
          key: "dent",
          label: "DENTAL",
        },
        {
          sortable: false,
          key: "ant",
          label: "ANTENENTAL",
        },
        {
          sortable: false,
          key: "pharmacy_field",
          label: "PHARMACY",
        },
      ],
    };
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("settings", ["SAVING", "Settings", "RoleNotifications"]),
  },
  methods: {
    ...mapActions({
      FetchSettings: "settings/fetchSettings",
      FetchRoleNotificationsx: "settings/fetchRoleNotifications",
      UpdateRoleNotification: "settings/updateRoleNotifications",
      UpdateSettings: "settings/updateSettings",
    }),
    changePermistion(col) {
      alert(col)
      let payload = {
        colomn: col,
        id: this.Settings.id,
      };
      this.UpdateSettings(payload);
    },
    updateNot(event, col, role) {
      let payload = { val: event.target.value, role: role, col: col };
      this.UpdateRoleNotification(payload);
    },
  },
  created() {
    this.FetchSettings();
    // this.FetchUserRoles();
    this.FetchRoleNotificationsx();
  },
};
</script>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="form-group"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body" v-if="Settings">
            <h4 class="card-title text-info">
              Manage General Settings
            </h4>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Setting</th>
                    <th>ON/OFF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Show Age or date of birth</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_age_or_dob == 1"
                          @change="changePermistion('show_age_or_dob')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_age_or_dob')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Temperature Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_temperature == 1"
                          @change="changePermistion('show_temperature')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_temperature')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Weight Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_weight == 1"
                          @change="changePermistion('show_weight')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_weight')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Pressure Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_pressure == 1"
                          @change="changePermistion('show_pressure')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_pressure')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Email Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_email == 1"
                          @change="changePermistion('show_email')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_email')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">NIN Number Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_nin == 1"
                          @change="changePermistion('show_nin')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_nin')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Show Next Of Kin Field</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_next_ofkin == 1"
                          @change="changePermistion('show_next_ofkin')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_next_ofkin')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                   <tr>
                    <th scope="row">Show Service Price on reciept</th>
                    <td>
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input
                          v-if="Settings.show_reciept_service_price == 1"
                          @change="changePermistion('show_reciept_service_price')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else
                          @change="changePermistion('show_reciept_service_price')"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                   <th scope="row">Pharmacy stock value calculation</th>
                    <td>
                    <select
                    v-if="Settings.pharmacy_stock_value == 1"
                     class="form-control" @change="changePermistion('pharmacy_stock_value')">
                    <option value="1" selected>By Buying price</option>
                    <option value="0">By Selling price</option>
                    </select>
                     <select
                      v-else
                     class="form-control" @change="changePermistion('pharmacy_stock_value')">
                    <option value="0" selected>By Selling price</option>
                    <option value="1">By Buying price</option>
                    </select>
                    </td>
                  </tr>
                    <tr>
                   <th scope="row">Print lab reports after payments</th>
                    <td>
                    <select
                     v-if="Settings.printLabReports == 1"
                     class="form-control" @change="changePermistion('printLabReports')">
                    <option selected value="1">ON</option>
                    <option value="0">OFF</option>
                    </select>
                    <select
                     v-else
                     class="form-control" @change="changePermistion('printLabReports')">
                    <option value="1">ON</option>
                    <option value="0" selected>OFF</option>
                    </select>
                    </td>
                  </tr>             
                       <tr>
                   <th scope="row">See Doctor after payments</th>
                    <td>
                    <select
                     v-if="Settings.seeDoctorAfterPay == 1"
                     class="form-control" @change="changePermistion('seeDoctorAfterPay')">
                      <option selected value="1">ON</option>
                      <option value="0">OFF</option>
                    </select>
                     <select
                     v-else
                     class="form-control" @change="changePermistion('seeDoctorAfterPay')">
                      <option value="1">ON</option>
                      <option selected value="0">OFF</option>
                    </select>
                  
                    </td>
                  </tr>
                   <tr>
                   <th scope="row">Diagnosis Type</th>
                    <td>
                    <select
                     v-if="Settings.diagnosisType == 1"
                     class="form-control" @change="changePermistion('diagnosisType')">
                       <option selected value="1">ICD 10</option>
                    <option value="0">Doctor entries</option>
                    </select>
                     <select
                     v-else
                     class="form-control" @change="changePermistion('diagnosisType')">
                       <option value="1">ICD 10</option>
                    <option selected value="0">Doctor entries</option>
                    </select>
                  
                    </td>
                  </tr>
                       
                </tbody>
              </table>
            </div>

            <center>
              <h2 class="text-info mt-4">USER ROLES AND NOTIFICATION SETTINGS</h2>
            </center>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive">
              <b-table
                class="datatables"
                :items="RoleNotifications ? RoleNotifications : []"
                :fields="fields"
                responsive="sm"
                :sort-desc.sync="sortDesc"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(lab_field)="data">
                  <select
                    class="form-control"
                    :value="data.item.lab"
                    @change="updateNot($event, 'laboratory_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(rad)="data">
                  <select
                    class="form-control"
                    :value="data.item.radiology"
                    @change="updateNot($event, 'radiology_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(dent)="data">
                  <select
                    class="form-control"
                    :value="data.item.dental"
                    @change="updateNot($event, 'dental_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(consult)="data">
                  <select
                    class="form-control"
                    :value="data.item.consultation"
                    @change="
                      updateNot($event, 'consultation_notifications', data.item.id)
                    "
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(proc)="data">
                  <select
                    class="form-control"
                    :value="data.item.procedure"
                    @change="updateNot($event, 'procedure_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(ant)="data">
                  <select
                    class="form-control"
                    :value="data.item.antenental"
                    @change="updateNot($event, 'antenental_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
                <template #cell(pharmacy_field)="data">
                  <select
                    class="form-control"
                    :value="data.item.pharmacy"
                    @change="updateNot($event, 'pharmacy_notifications', data.item.id)"
                  >
                    <option value="1">ON</option>
                    <option value="0">OFF</option>
                  </select>
                </template>
              </b-table>
            </div>
          </div>
          <div class="card-body" v-else>
            <h2 class="text-center">
              <b-spinner
                  class="m-0"
                  variant="danger"
                  role="status"
              ></b-spinner>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
